import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
export const OidcConfigurationActions = Reflux.createActions({
  getConfig: { asyncResult: true }
});
export const OidcConfigurationStore = Reflux.createStore({
  listenables: [OidcConfigurationActions],
  sourceUrl: "/plugins/org.graylog.plugins.security/oauth/authconfig",
  configuration: void 0,
  error: void 0,
  getState() {
    return {
      configuration: this.configuration,
      error: this.error
    };
  },
  getInitialState() {
    return this.getState();
  },
  propagateState() {
    this.trigger(this.getState());
  },
  getConfig() {
    const promise = fetch("GET", qualifyUrl(this.sourceUrl), null, false).then(
      (response) => {
        this.configuration = response;
        this.propagateState();
        return response;
      },
      (error) => {
        this.error = error;
        this.propagateState();
      }
    );
    OidcConfigurationActions.getConfig.promise(promise);
  }
});
